import d from 'debug';

import type { IninChatSubscribeHandler } from '../types';
import { GenesysServerProxy } from './GenesysServerProxy';

const debug = d('genesys-widget:inin-chat');

export const ininChatEvents = {
  INIT: 'OriChatInitPublic',
  READY: 'OriChatReadyPublic',
  COMPLETE: 'OriChatCompletePublic',
  OPEN_ERROR: 'OriChatOpenErrorPublic',
  CHAT_DISCONNECT: 'OriChatDisconnectedPublic',
  RECONNECT_FAILURE: 'OriChatReconnectFailurePublic',
  CLOSE: 'OriClosePublic',
};

export const getIninChat = (
  handleOpenChat: () => void,
  setButtonVisibility: (value: boolean) => void,
) => {
  const ininChat = window.ori?.ininChat;

  debug('existing ininchat', ininChat);

  const instance = {
    elementId: 'genesys-widget-root',
    events: {
      ...ininChatEvents,
      subscribe: (eventType: string, handler: IninChatSubscribeHandler) => {
        debug(`subscribe to ${eventType}`);
        instance.events.handlers[eventType] = handler;
      },
      unsubscribe: (eventType: string) => {
        debug(`unsubscribe from ${eventType}`);
        delete instance.events.handlers[eventType];
      },
      handlers: {},
    },
    server: new GenesysServerProxy(),
    iFrame: {
      load: handleOpenChat,
    },
    toggleVisibility: (value?: boolean) => {
      debug(`toggle visibility ${value ? 'on' : 'off'}`);

      if (value) {
        if (window.ori?.genesysPlugin) {
          window.ori?.genesysPlugin.command('WebChat.show');
        }
        setButtonVisibility(true);
      } else {
        if (window.ori?.genesysPlugin) {
          window.ori?.genesysPlugin.command('WebChat.hide');
        }
        setButtonVisibility(false);
      }
    },
    triggerEvent: (eventType: string, ...params) => {
      debug(`trigger event ${eventType}`, params);
      instance.events.handlers[eventType]?.(params);
    },
    handleClose: () => {
      debug('handle close');
      instance.triggerEvent(instance.events.CLOSE);
    },
    openChatWindow: () => {},
    getChatId: () => '',
    clearUserData: () => {},
    toggle: () => {},
  };

  return instance;
};
